/* eslint-disable no-unused-vars */
/**
 * Everything im here should return a promise to be used by react-query
 */
import {
	auth,
	EmailAuthProvider,
	LOCAL_PERSIST,
	firestore
} from "../services/firebase";

export const USER_STORAGE_KEY = "user";

export function signIn(_key, email, password) {
    return auth
        .setPersistence(LOCAL_PERSIST)
        .then(() => auth.signInWithEmailAndPassword(email, password))
        .then(async (userCredential) => {
            // Get user document from Firestore
            const userDoc = await firestore.collection("Users").doc(userCredential.user.uid).get();
			const userData = userDoc.data();
            // Check if user is admin or has roles (bar manager)
            const isAdmin = userData?.isAdmin === true;

			const hasRoles = userData?.roles && Object.keys(userData?.roles).length > 0;
			// Previously blocked users without roles; now allow sign-in so UI can show appropriate state.
			return userCredential;
        });
}

export function signOut() {
	return auth.signOut();
}

export async function changePassword(password, newPassword) {
	const { currentUser } = auth;

	try {
		await auth.signInWithEmailAndPassword(
			currentUser.email,
			password
		);
		await currentUser.updatePassword(newPassword);
		return Promise.resolve();
	} catch (e) {
		return Promise.reject(e);
	}
}
